import { Address } from '~domains/partner-application/entities/application';
import { compareAddresses } from '~domains/partner-application/entities/application/lib/recover/compare-addresses';

import { InfoCard } from '~shared/ui/info-card';

import { Typography } from '@breezeventures/ui-kit/typography';

import { AddressReviewItems } from './address-review-items';

type OfficeAddressReviewProps = {
  officeAddress: Address | undefined;
  registeredAddress: Address | undefined;
  onEdit?: () => void;
};

export const OfficeAddressReview = ({
  officeAddress,
  registeredAddress,
  onEdit,
}: OfficeAddressReviewProps) => {
  if (!officeAddress) {
    return null;
  }

  const sameAsRegistered =
    !!registeredAddress && compareAddresses(officeAddress, registeredAddress);

  return (
    <InfoCard header="Main Office address" onEdit={onEdit}>
      {sameAsRegistered ? (
        <Typography.Text size="s">Same as registered address</Typography.Text>
      ) : (
        <div className="grid grid-cols-2 gap-4">
          <AddressReviewItems address={officeAddress} />
        </div>
      )}
    </InfoCard>
  );
};
